// extracted by mini-css-extract-plugin
export default {"inputWrapper":"input_inputWrapper__LzZrX"};